import { useRouter } from '@tanstack/react-router'
import { Alert, AlertDescription, AlertTitle } from '@trellis/roots/alert'
import { Button } from '@trellis/roots/button'

interface RouteErrorFallbackProps {
  error: Error
}

export function RouteErrorFallback({ error }: RouteErrorFallbackProps) {
  const router = useRouter()

  return (
    <div className="mx-auto max-w-[800px] p-8 text-center">
      <Alert variant="destructive" className="text-left">
        <AlertTitle>Something went wrong</AlertTitle>
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
      <Button variant="outline" className="mt-6" onClick={() => void router.invalidate()}>
        Retry
      </Button>
    </div>
  )
}
